<template>
    <div class="modal fade" :id="idmodal">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="moda-title m-0">{{title}}</h5>
                </div>
                <div class="modal-body">
                    <form :id="idform" :get="get" :post="post" :paginate="paginate" :onload="onload" :par="par">
                        <slot :prop="prop" :data="data"></slot>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';
export default {
    props: [
        'title',
        'idmodal',
        'idform',
        'get',
        'post',
        'paginate',
        'onload',
        'par',
    ],
    data() { return {
        prop: {},
        data: {},
        select: {},
        page: 1,
        params: {},
        run: false,
        selected: -1,
    }},
    mounted() {
        this.$on('bcRefrescarSelect', function(who, val){
            this.$emit('bcRefrescarChild', who, val);
        });

        const vm = this;
        $('#'+this.idmodal).on('show.bs.modal', function (event) {
            reactiveCurrentOpenModal = '#' + this.idmodal;
            vm.selected= $(event.relatedTarget).find("span[class=btnModalGetClass]").html()
            vm.getM(vm.get + '/' + vm.selected);
        });

        const elem = $("#"+(this.idform ? this.idform : 'vueReactiveForm'));
        elem.submit(function(event) {
            event.preventDefault();
            
            if(vm.$props.post !== '') {
                const data = elem.serialize();
                vm.postM(data);
            }
        }); 
    },
    methods: {
        postM: function(data) {
            axios.post(this.$props.post + '/' + this.selected, data).then(response => {
                toastr["success"](response.data.message, "Registro actualizado con éxito");
                $(reactiveCurrentOpenModal).modal('hide');
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', e);
            });
        },
        getM: function(url) {
            setTimeout(() => {
                Axios.get(url).then(res => {
                    this.data = res.data;                     
                });
            }, 500);
        },
        infiniteHandler: async function($state) {
            await this.getM(this.$props.get).then(again => {
                if(again) {
                    $state.loaded();
                } else {
                    $state.complete();
                }
            });
        }, 
        refresh: function() {
            if(this.$refs.infiniteLoading) {
                this.data = [];
                this.page = 1;
                this.$refs.infiniteLoading.stateChanger.reset(); 
            }
        },  
    }
}
</script>